import React, { Component } from 'react';
import moment from 'moment';
import cx from 'classnames';
import withStyles from '@mui/styles/withStyles';
import Hidden from '../../../component/Hidden';
import Modal from '../extras/Modal';
import Task from '../Task';
import TaskModalDetail from './TaskModalDetail';
import DataFormView from '../../../component/form/v2/DataFormView';
import { getMyClient } from '../../../apollo';
import { getUser } from '../../../util/sessions';
import { validationHelper } from '../../../util/validation';
import { isNullOrUndefined } from '../../../util/objects';
import CloseIcon from '../extras/CloseIcon';
import { OutlineButton } from '../../../component/form/PrimaryButton';

const StyledComponent = withStyles({})(TaskModalDetail);
export const taskTabs = [
    {
        id: 'Task',
        label: 'Task',
        component: StyledComponent,
        fragment: Task,
        formatSaveData: (saveData, state) => {
            const localAssignedMembers = [];
            if (!state.ID || (saveData && saveData.AssignedMembers)) {
                state.AssignedMembers.forEach(function(member) {
                    if (!!member.ID) {
                        localAssignedMembers.push({
                            ID: member.ID
                        });
                    }
                });

                saveData.AssignedMembers = localAssignedMembers;
            }

            const localAssignedTeams = [];
            if (saveData && saveData.AssignedTeams) {
                state.AssignedTeams.forEach(function(team) {
                    if (!!team.ID) {
                        localAssignedTeams.push({
                            ID: team.ID
                        });
                    }
                });

                saveData.AssignedTeams = localAssignedTeams;
            }

            if (saveData && saveData.Cremation && saveData.Cremation.ID) {
                saveData.CremationID = saveData.Cremation.ID;
            }
            if (saveData && saveData.Plaque && saveData.Plaque.ID) {
                saveData.PlaqueID = saveData.Plaque.ID;
            }
            if (saveData && saveData.EnquiryCM && saveData.EnquiryCM.ID) {
                saveData.EnquiryCMID = saveData.EnquiryCM.ID;
            }
            if (saveData && saveData.EnquiryFM && saveData.EnquiryFM.ID) {
                saveData.EnquiryFMID = saveData.EnquiryFM.ID;
            }
            if (saveData && saveData.Funeral && saveData.Funeral.ID) {
                saveData.FuneralID = saveData.Funeral.ID;
            }
            delete saveData.Cremation;
            delete saveData.Plaque;
            delete saveData.EnquiryCM;
            delete saveData.EnquiryFM;
            delete saveData.Funeral;
        },
        validation: {
            required: ['Title'],
            suggested: ['LinkURL', 'Description'],
            onValidate: {
                Due: (newValue, persistedValue, hasValue, getField) => {
                    if (!hasValue && isNullOrUndefined(newValue)) {
                        if (getField('Category') === 'Goal') {
                            return validationHelper.required('This field is required for goals');
                        } else {
                            return validationHelper.suggested('This field could be useful');
                        }
                    } else if (!moment(getField('Due')).isValid()) {
                        return validationHelper.required('Date/time is invalid');
                    }
                    return validationHelper.ok();
                },
                Funeral: (newValue, persistedValue, hasValue, getField) => {
                    const val = newValue || persistedValue || null;
                    if (getField('Category') === 'Funeral' && (!val || isNullOrUndefined(val.ID) || !Number(val.ID))) {
                        return validationHelper.required();
                    }
                    return validationHelper.ok();
                },
                EnquiryFM: (newValue, persistedValue, hasValue, getField) => {
                    const val = newValue || persistedValue || null;
                    if (
                        getField('Category') === 'EnquiryFM' &&
                        (!val || isNullOrUndefined(val.ID) || !Number(val.ID))
                    ) {
                        return validationHelper.required();
                    }
                    return validationHelper.ok();
                },
                Cremation: (newValue, persistedValue, hasValue, getField) => {
                    const val = newValue || persistedValue || null;
                    if (
                        getField('Category') === 'Cremation' &&
                        (!val || isNullOrUndefined(val.ID) || !Number(val.ID))
                    ) {
                        return validationHelper.required();
                    }
                    return validationHelper.ok();
                },
                Plaque: (newValue, persistedValue, hasValue, getField) => {
                    const val = newValue || persistedValue || null;
                    if (getField('Category') === 'Plaque' && (!val || isNullOrUndefined(val.ID) || !Number(val.ID))) {
                        return validationHelper.required();
                    }
                    return validationHelper.ok();
                },
                EnquiryCM: (newValue, persistedValue, hasValue, getField) => {
                    const val = newValue || persistedValue || null;
                    if (
                        getField('Category') === 'EnquiryCM' &&
                        (!val || isNullOrUndefined(val.ID) || !Number(val.ID))
                    ) {
                        return validationHelper.required();
                    }
                    return validationHelper.ok();
                },
                AssignedMembers: (newValue, persistedValue, hasValue, getField) => {
                    const teams = getField('AssignedTeams') || [];
                    if (!teams.length && !(newValue && newValue.length) && !(persistedValue && persistedValue.length)) {
                        return validationHelper.required('Task must be assigned to staff or team.');
                    }
                    return validationHelper.ok();
                }
            }
        }
    }
];

class TaskModal extends Component {
    state = {
        itemID: null
    };

    static getDerivedStateFromProps({ taskID, open }, { itemID }) {
        if (false === open) {
            return { itemID: null };
        }
        if (taskID && (!itemID || taskID !== itemID)) {
            return { itemID: taskID };
        }

        return null;
    }

    render() {
        const { open, onClose, onSaved, onCreateNew, classes } = this.props;
        const { itemID } = this.state;
        return (
            <Modal
                open={open}
                variant="task"
                onClose={onClose}
                taskid={itemID}
                title={itemID ? 'Edit Task' : 'Add New Task'}
                canClickOut={false}
            >
                <DataFormView
                    tabs={taskTabs}
                    createNewFunc={() => ({
                        IsRecurring: null,
                        TaskFrequency: null,
                        AssignedMembers: [getUser()],
                        AssignedTeams: [],
                        Due: null,
                        Description: null,
                        Title: null,
                        Funeral: null,
                        EnquiryFM: null
                    })}
                    objectType="Task"
                    name="Task"
                    context={this}
                    createNew={!itemID}
                    itemId={itemID}
                    client={getMyClient()}
                    onUpdated={onSaved} // after save existing object
                    onCreated={onCreateNew ? onCreateNew : e => this.onCreateNew(e)} // after creating new object
                    additionalActions={[
                        {
                            label: (
                                <>
                                    <CloseIcon />
                                    <Hidden smDown>Close</Hidden>
                                </>
                            ),
                            component: OutlineButton,
                            onClick: onClose,
                            skipSave: true
                        }
                    ]}
                    classes={{
                        footerButtonsContainer: cx(classes.saveButtonContainer, 'modal-footer.paper'),
                        saveButton: classes.saveButton
                    }}
                />
            </Modal>
        );
    }

    onCreateNew(obj) {
        this.setState({ itemID: obj.ID });
    }
}

const styles = ({ breakpoints }) => ({
    saveButtonContainer: {
        position: 'static',
        minWidth: 'unset'
    },
    saveButton: {
        [breakpoints.down('sm')]: {
            minWidth: 'unset',
            bottom: 0,
            right: 0,
            padding: '10px',
            borderRadius: 64,
            height: 'fit-content',
            '& span > span': {
                display: 'block'
            },

            '& span > svg': {
                display: 'block',
                margin: 0,
                height: 20,
                width: 20,
                marginRight: 12
            }
        }
    }
});

export default withStyles(styles)(TaskModal);
